import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';
// import * as constants from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

// export async function getApiOpenBets() {
//     try {
//         const response = await serviceContext.get(ReportsURL + "openbets", null, options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };
export async function postApiOpenBets(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}bets/open`, JSON.stringify(data), options); //+ "openbets", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};
// export async function postApiOpenBetsCsv(data) {

//     try {
//         const response = await serviceContext.post(ReportsURL + "openbets/csv", JSON.stringify(data), options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };
// export async function postApiOpenBetsPdf(data) {

//     try {
//         const response = await serviceContext.post(ReportsURL + "openbets/pdf", JSON.stringify(data), options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

export async function getEventListByEventTypeName(event_type_name) {
    try {
        const response = await serviceContext.get(`${ReportsURL}event/open/${event_type_name}` , null, options);//+ "openbets/eventslist/" + event_type_name, null, options);
        const res = response.json();
        return res;
    }
    catch (error) {
        return error;
    }
};
export async function getMarketListByEventName(event_name, bettingType) {
    try {
        const response = await serviceContext.get(`${ReportsURL}market/open/${event_name}/${bettingType}`, null, options); //+ "openbets/marketslist/" + event_name, null, options);
        const res = response.json();
        return res;
    }
    catch (error) {
        return error;
    }
};